import { useContext } from "react";
import { AppContext } from "components/app/RemExprertProvider";
import TextField from "components/ui/controls/text-field/text-field";
import CardBox, { CardBoxHeader } from "components/ui/controls/card-box/card-box";
import Column from "components/ui/layout/column/column";
import Row from "components/ui/layout/row/row";
import { FaTable } from "react-icons/fa";

function ContratSante(props) {
  const context = useContext(AppContext);

  return (
    <>
      <Column fill>
        <CardBox>
          <Column fill>
          {props.AccessRemExpress === false && (
            <Row>
              <Column>
                <TextField label="Libellé" value={context.state.LibelleContratSante} onChange={context.handleInputChange("LibelleContratSante")} normal />
              </Column>
            </Row>
          )}
            {props.Statut === "TNS Article 62" || props.Statut  === "TNS individuel" ? (
              <>
                <Row tpad>
                  <Column>
                    <TextField
                      label="Cotisation Madelin annuelle"
                      value={context.state.SanteMadelin}
                      onChange={context.handleInputChange("SanteMadelin")}
                      dataType="uint"
                      format={{ thousands: " ", unit: " €" }}
                      normal
                    />
                  </Column>
                  <Column>
                    <TextField
                      label="Cotisation non Madelin annuelle"
                      value={context.state.SanteNonMadelin}
                      onChange={context.handleInputChange("SanteNonMadelin")}
                      dataType="uint"
                      format={{ thousands: " ", unit: " €" }}
                      normal
                    />
                  </Column>
                </Row>
              </>
            ) : (
              <Row tpad>
                <Column fill>
                  <CardBoxHeader icon={<FaTable style={{ color: "#6b7280", fontSize: 14 }} />}>
                    <span style={{ color: "rgb(55, 65, 81)", fontSize: 14, fontWeight: 600, fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif", letterSpacing: "-0.01em" }}>
                      Tableau des cotisations santé
                    </span>
                  </CardBoxHeader>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      width: "100%",
                      maxWidth: 700,
                      margin: "8px 0",
                      paddingLeft: 13,
                      boxSizing: "border-box",
                      fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
                      fontSize: 13,
                      color: "#64748b",
                      fontWeight: 600,
                      letterSpacing: "-0.01em",
                    }}
                  >
                    <span style={{ width: 220, marginRight: 18 }} />
                    <span style={{ width: 180, marginRight: 18, textAlign: "center" }}>Salarié</span>
                    <span style={{ width: 180, textAlign: "center" }}>Employeur</span>
                  </div>
                  <ul style={{ listStyle: "none", padding: 0, margin: 0, width: "100%", maxWidth: 700 }}>
                    <li
                      style={{
                        background: "#fff",
                        borderRadius: "12px",
                        boxShadow: "0 1px 4px rgba(99,102,241,0.06)",
                        padding: "8px 12px",
                        marginBottom: "14px",
                        display: "flex",
                        alignItems: "center",
                        border: "1.5px solid #d1d5db",
                        transition: "box-shadow 0.2s",
                      }}
                    >
                      <span
                        style={{
                          width: 220,
                          marginRight: 18,
                          fontWeight: 700,
                          fontSize: "12px",
                          color: "#6366f1",
                          fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
                          background: "#f1f5ff",
                          border: "1.5px solid #6366f1",
                          borderRadius: "8px",
                          padding: "4px 12px",
                          boxSizing: "border-box",
                        }}
                      >
                        Frais de santé sur le PASS
                      </span>
                      <TextField
                        aria-label="Taux salarié des frais de santé sur le PASS"
                        value={context.state.Taux83Sante.taux_sante_salarie83}
                        onChange={(e) => context.handleObjectChange("Taux83Sante", "taux_sante_salarie83", e)}
                        dataType="ufloat"
                        format={{ thousands: " ", precision: 2, decimal: ",", unit: "%" }}
                        style={{ width: "180px", marginRight: 18 }}
                      />
                      <TextField
                        aria-label="Taux employeur des frais de santé sur le PASS"
                        value={context.state.Taux83Sante.taux_sante_patronale83}
                        onChange={(e) => context.handleObjectChange("Taux83Sante", "taux_sante_patronale83", e)}
                        dataType="ufloat"
                        format={{ thousands: " ", precision: 2, decimal: ",", unit: "%" }}
                        style={{ width: "180px" }}
                      />
                    </li>
                  </ul>
                </Column>
              </Row>
            )}
          </Column>
        </CardBox>
      </Column>
    </>
  );
}

export default ContratSante;
